export enum Pairs {
  BTC = "BTC_USDC",
  ETH = "ETH_USDC",
}

export enum MarginAccountStatePairs {
  BTC = "BTC_USDC",
  ETH = "ETH_USDC",
  USDC = "USDC_USDC",
}

export enum PortfolioSymbol {
  BTC = "BTC",
  ETH = "ETH",
  USDC = "USDC",
}

export type PortfolioSymbolType = keyof typeof PortfolioSymbol;
export type UnderlyingSymbol = Exclude<keyof typeof PortfolioSymbol, "USDC">;
export type MarketPair = (typeof Pairs)[keyof typeof Pairs];
export type MarginAccountStatePairsType =
  (typeof MarginAccountStatePairs)[keyof typeof MarginAccountStatePairs];

export interface Market {
  underlying: UnderlyingSymbol;
  pair: MarketPair;
}
